import { FC } from 'react';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import GamesSectionHeader from '../../GamesSectionHeader';
import { AnotherCasinoTypeItem } from './AnotherCasinoTypeItem';
import { AnotherCasinoTypeList } from './AnotherCasinoTypeList';
import { IAnotherCasinoTypeProps } from './types';

export const AnotherCasinoType: FC<IAnotherCasinoTypeProps> = ({
  feedName,
  gamesServiceUrl
}) => {
  const logAmplitude = useLogAmplitude();

  const analyticOpenCategory = (categoryName: string) => {
    logAmplitude({
      actionName: LOG_ACTIONS.CASINO_LOBBY_LIVE_GAMES_CATEGORY_OPEN_CATEGORY,
      attributes: {
        category_name: categoryName
      }
    });
  };

  const analyticOpenViewAll = () => {
    logAmplitude({
      actionName: LOG_ACTIONS.CASINO_LOBBY_LIVE_GAMES_CATEGORY_VIEW_ALL
    });
  };

  return (
    <AnotherCasinoTypeList
      feedName={feedName}
      gamesServiceUrl={gamesServiceUrl}
      headerComponent={GamesSectionHeader}
      itemComponent={AnotherCasinoTypeItem}
      analyticOpenCategory={analyticOpenCategory}
      analyticOpenViewAll={analyticOpenViewAll}
      showArrows={true}
      spaceBetween={8}
      slidesPerView="auto"
    />
  );
};
